import { createRef, Component, Fragment } from 'react';

import Field from './Field';
import { withPreviewContext } from './Context';

class Page extends Component {
    state = {
        elementWidth: 0
    };

    pageWrapper = null;

    constructor(props) {
        super(props);

        this.pageWrapperRef = createRef();
        this.ref = createRef();
    }

    setPageElement = element => {
        if (!element) {
            return;
        }

        this.pageWrapper = element;

        const { preview, index } = this.props;

        preview.setPageElement(index, element);
    };

    render() {
        const { index, preview } = this.props;

        const page = preview.state.envelope.pages[index];

        const { zoomFactor } = preview.state;

        const width = parseFloat(page.width) * (zoomFactor > 0 ? zoomFactor : 1);

        return (
            <div className="addendum-viewer-page-zoom-wrapper" style={{ width: `${width}px` }}>
                <div
                    className="addendum-viewer-page-wrapper"
                    ref={this.setPageElement}
                    style={{
                        paddingTop: `${(page.height / page.width) * 100}%`
                    }}
                >
                    <div className="addendum-viewer-page-container" ref={this.refCallback}>
                        <img src={page.imageUrl} alt={`Addendum Image ${page.orderIndex}`} />

                        {page.fields.map((field, fieldIndex) => {
                            return (
                                <Fragment key={fieldIndex}>
                                    <Field pageIndex={index} index={fieldIndex} containerWidth={width} signature={this.props.signature} form={this.props.form} />
                                </Fragment>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default withPreviewContext(Page);
